import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { crossPlatformStorage } from './storage';

export type ErrorLogLevel = 'error' | 'warn';

export type ErrorLogContextValue =
  | string
  | number
  | boolean
  | null
  | Array<string | number | boolean | null>
  | Record<string, string | number | boolean | null>;

export interface ErrorLogEntry {
  id: string;
  timestamp: string;
  level: ErrorLogLevel;
  source: string;
  message: string;
  status?: number;
  code?: string;
  method?: string;
  url?: string;
  context?: Record<string, ErrorLogContextValue>;
}

interface ErrorLogState {
  entries: ErrorLogEntry[];
  addEntry: (entry: Omit<ErrorLogEntry, 'id' | 'timestamp'> & { timestamp?: string }) => void;
  clearEntries: () => void;
}

const MAX_ERROR_LOG_ENTRIES = 1000;

export const useErrorLogStore = create<ErrorLogState>()(
  persist(
    (set) => ({
      entries: [],
      addEntry: (entry) =>
        set((state) => ({
          entries: [
            {
              ...entry,
              id: `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`,
              timestamp: entry.timestamp ?? new Date().toISOString(),
            },
            ...state.entries,
          ].slice(0, MAX_ERROR_LOG_ENTRIES),
        })),
      clearEntries: () => set({ entries: [] }),
    }),
    {
      name: 'smarthome-error-log',
      storage: crossPlatformStorage,
      partialize: (state) => ({ entries: state.entries }),
    }
  )
);
